module.exports = __webpack_public_path__ + "img/graduated.a53ce514.svg";